import Image from "../../components/img";

const Main = () => {
  return (
    <div className="flex flex-col justify-center items-center min-h-screen">
      <Image />
    </div>
  );
};

export default Main;
